import { useLocation } from "react-router-dom";

export const useGetCourseFromUrl = () => {
  const location = useLocation();
  const splittedPath = location.pathname.split("/");

  return splittedPath[2];
};
